const kellyColors = [
  '#e6194B',
  '#3cb44b',
  '#ffe119',
  '#4363d8',
  '#f58231',
  '#911eb4',
  '#42d4f4',
  '#f032e6',
  '#bfef45',
  '#fabed4',
  '#469990',
  '#dcbeff',
  '#9A6324',
  '#fffac8',
  '#800000',
  '#aaffc3',
  '#808000',
  '#ffd8b1',
  '#000075',
  '#a9a9a9',
  '#ffffff',
  '#000000'
]

const blackTextColors = [
  '#ffe119',
  '#42d4f4',
  '#bfef45',
  '#fabed4',
  '#dcbeff',
  '#fffac8',
  '#aaffc3',
  '#ffd8b1',
  '#ffffff',
]

const sceneColors = {}
function sceneColor (name) {
  if (!Object.prototype.hasOwnProperty.call(sceneColors, name)) {
    if (kellyColors.length) {
      const backgroundColor = kellyColors.shift()
      sceneColors[name] = {
        backgroundColor,
        color: blackTextColors.includes(backgroundColor) ? 'black' : 'white',
      }
    } else {
      // 超过20种直接黑色
      sceneColors[name] = {
        backgroundColor: '#000000',
        color: 'white',
      }
    }
  }
  return sceneColors[name]
}

export default sceneColor



// WEBPACK FOOTER //
// ./src/views/question-review/packages/AnswerFileList/scene-color.js